import React from 'react';
import { statsData, siteConfig } from '../../data/mock';
import { ArrowRight, TrendingUp } from 'lucide-react';

const StatsSection = () => {
  return (
    <section className="py-12 sm:py-16 bg-white relative overflow-hidden">
      {/* Subtle Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, var(--brand-teal-600) 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-8 sm:mb-10">
          <div className="inline-flex items-center gap-2 bg-[var(--brand-teal-50)] border border-[var(--brand-teal-100)] rounded-full px-4 py-2 mb-4">
            <TrendingUp className="w-4 h-4 text-[var(--brand-teal-600)]" />
            <span className="text-sm font-medium text-[var(--brand-teal-700)]">Proven Results</span>
          </div>
          <h2 className="heading-1 text-[var(--text-primary)] mb-3">
            Numbers That Speak for Themselves
          </h2>
          <p className="body-large text-[var(--text-secondary)] max-w-2xl mx-auto text-sm sm:text-base">
            Join the growing number of sales and recruiting professionals 
            who&apos;ve transformed their outreach with SuperHunt.
          </p>
        </div>

        {/* Stats Grid - Teal blocks */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 mb-8 sm:mb-10">
          {statsData.map((stat, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[var(--brand-teal-600)] to-[var(--brand-teal-700)] rounded-xl sm:rounded-2xl p-4 sm:p-5 text-center hover:shadow-lg transition-shadow group"
            >
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-1 group-hover:scale-105 transition-transform">
                {stat.value}
              </div>
              <div className="text-white/80 text-xs sm:text-sm font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* CTA - Teal button */}
        <div className="text-center">
          <a
            href={siteConfig.calendlyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-[var(--brand-teal-700)] hover:bg-[var(--brand-teal-800)] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold transition-all hover:translate-y-[-2px] shadow-lg shadow-[var(--brand-teal-600)]/20 group w-full sm:w-auto"
          >
            Join the SuperHunt Transformation Journey
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
